import React from 'react';
import { compose, is } from 'ramda';

import styleFile from './Modal.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { showPopover } from '../../providers/popoverProvider.jsx';
import Button from '@synergycms_core/components/generic/Button';

const ModalBox = class ModalBox extends React.Component {

  static displayName = 'ModalBox';
  
  constructor(props) {
    super(props);
  }
  render() {
    const { type, toggle, close,  defaultStyle, modalStyle, contentStyle, filterModal, closeButtonStyle } = this.props.config;
    const { classes } = this.props.theme.styles;
    return (
      <div
        onClick={toggle}
        id={type}
        className={this.props.theme.styleGetter([
          defaultStyle !== false && classes.modalStyle,
          modalStyle
        ])}>
        <div className={classes.contentTable}>
          <div className={classes.contentFather}>
            <div
              onClick={e => e.stopPropagation()}
              className={contentStyle || classes.content}>
              {!filterModal && (
                <Button
                  onClick={close}
                  innerStyle={closeButtonStyle || classes.closeButton}
                  icon={{ unicodeContent: 'e001' }}
                  defaultStyle={false}
                />
              )}
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
  
};

export default compose(
  showPopover,
  PropertyManager([
    "parsedPopover",
    "type",
    "close",
    "toggle",
    "defaultStyle",
    "modalStyle",
    "contentStyle",
    "filterModal",
    "closeButtonStyle",
  ]),
  withThemeJSS({ styleFile, link: true, index: 10 })
)(ModalBox);